import { defineRecipe } from '@chakra-ui/react'

// Field Green Badge: tightened radii.xs and label-weight type (12px/550,
// no uppercase). StatusChip (Task 7) renders a Badge and inherits this base
// shape/type for free; colour/meaning (colorPalette, variant) stays per-site
// until slices 6/8 — this task restyles shape/type only, on all ~223
// existing <Badge> call sites.
//
// Stock badge recipe (node_modules/@chakra-ui/react/dist/esm/theme/recipes/
// badge.js) sets `borderRadius: 'l2'` and `fontWeight: 'medium'` in its own
// `base` — those two survive a plain `base` override fine, confirmed via
// `system.getRecipeFn('badge')({})` (see recipes.test.ts).
//
// BUT every stock `size` variant (xs/sm/md/lg) sets `textStyle`, a shorthand
// that expands to `fontSize`/`lineHeight` during css() compilation. Because
// variant styles are merged over base via `Object.assign`, a key that's new
// to the accumulator (like `textStyle`, which base never had) is appended at
// the END of the merged object regardless of where it sat in the variant's
// own literal — so it is always resolved *after* our base `fontSize`, and
// wins. This is the same class of defeat as Task 3's checkbox `_checked`
// collision (selection.recipe.ts), just via shorthand expansion order rather
// than a literal selector tie; confirmed empirically (`fontSize` resolved to
// `var(--chakra-font-sizes-xs)`, not `12px`, before this fix). Fixed by
// neutralizing `textStyle` to Chakra's built-in empty text style (`'none'`,
// see node_modules/.../theme/text-styles.js) on every size step, so the
// shorthand expands to nothing and our base `fontSize`/`fontWeight` stand.
// `px`/`minH` per size step are untouched (deep-merged, not replaced).
export const badgeRecipe = defineRecipe({
  base: {
    borderRadius: 'xs',
    fontWeight: 550,
    fontSize: '12px',
    textTransform: 'none',
  },
  variants: {
    size: {
      xs: { textStyle: 'none' },
      sm: { textStyle: 'none' },
      md: { textStyle: 'none' },
      lg: { textStyle: 'none' },
    },
  },
})
